import {  ChangeDetectorRef, Component, EventEmitter, HostListener, Output, ViewChild } from '@angular/core';
import {  FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NzButtonSize } from 'ng-zorro-antd/button';
import { PaginationComponent } from '@shared/components/pagination/pagination.component';
import { NzDropdownMenuComponent } from 'ng-zorro-antd/dropdown';
import { UsuarioService } from '@core/services/usuario.service';
import { RelatoriosService } from '@core/services/relatorios.service';
import { MessageService } from '@core/services/message.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { RoleEnum } from '@core/models/role';
import { ColumnOrder } from '@core/table/order';


export interface RelatorioEmailDTO {
  id: number;
  email: string;
  tela: string;
  tipoContato: string;
}

@Component({
  selector: 'app-relatorio-email-geral',
  templateUrl: './relatorio-email-geral.component.html',
  styleUrl: './relatorio-email-geral.component.scss'
})
export class RelatorioEmailComponent {

  @ViewChild(PaginationComponent)
  paginator!: PaginationComponent;
  size: NzButtonSize = 'large';

  relatorioEmailForm!: FormGroup;
  usuarioList: any[] = [];
  tipoArquivoList: any[] = [];
  origemArquivoList: any[] = [];
  origemConsultasMailingList: any[] = [];
  dataSet: any;
  filtro: any;
  perfilUsuarioLogado: any;
  menu!: NzDropdownMenuComponent;
  nzFilterOption = (): boolean => true;

  @Output() change = new EventEmitter<any>();

  columOrder: ColumnOrder | undefined;

  constructor(
    private fb: FormBuilder,
    private relatoriosService: RelatoriosService,
    private changeDetector: ChangeDetectorRef,
    public route: ActivatedRoute,
        private ngxPermissionService: NgxPermissionsService,


   private messageService: MessageService
  ) {}

  ngOnInit() {
    this.construirForm();
  }



  ngAfterViewInit() {
    this.changeDetector.detectChanges();
    this.paginator.change.subscribe(() => {
      this.consultar();
    });  }

  construirForm() {
    this.relatorioEmailForm = this.fb.group(
      {
        email: [null, [Validators.required]]
      },

    );
  }



  pesquisar() {
  this.filtro = this.relatorioEmailForm.value;
  this.paginator.reset();
  this.consultar();
  }


  consultar() {
    this.relatoriosService.consultarRelatorioEmailSort(
      this.filtro,
      this.paginator.pagination,
      this.columOrder || {}
    ).subscribe(data => {
      this.dataSet = data.content;
      this.paginator.totalItens = data.totalElements;
    });
  }


  sort(event: any) {
    const itemSelected = event.sort.find((x: any) => x.value);
    if (itemSelected) {
      this.columOrder = { sortField: itemSelected.key, sortOrder: itemSelected.value };
      this.consultar();
    }
  }

  navegarParaDetalhe(item: RelatorioEmailDTO): void {
    if (!item || !item.tela || !item.id) {
      this.messageService.warning('Dados inválidos para navegação!');
      return;
    }

    let rota = '';

    const temPermissaoEditarPessoa = this.ngxPermissionService.getPermission(RoleEnum.PessoaGravacao);
    const temPermissaoEditarVinculo = this.ngxPermissionService.getPermission(RoleEnum.VinculoEdicao);
    const temPermissaoEditarEntidade = this.ngxPermissionService.getPermission(RoleEnum.EntidadeGravacao);
    const temPermissaoEditarUsuario = this.ngxPermissionService.getPermission(RoleEnum.UsuarioGravacao);
    const href = "/#";

    switch (item.tela.toLowerCase()) {
      case 'vinculo':
        rota = temPermissaoEditarVinculo ? `${href}/vinculo/editar/${item.id}` : `${href}/vinculo/visualizar/${item.id}`;
        break;
      case 'entidade':
        rota = temPermissaoEditarEntidade ? `${href}/entidade/editar/${item.id}` : `${href}/entidade/visualizar/${item.id}`;
        break;
      case 'pessoa':
        rota = temPermissaoEditarPessoa ? `${href}/pessoa/editar/${item.id}` : `${href}/pessoa/visualizar/${item.id}`;
        break;
      case 'usuario':
        if (temPermissaoEditarUsuario) {
          rota = `${href}/usuario/editar/${item.id}`;
        } else {
          this.messageService.error('Usuário sem permissão de acesso.');
          return;
        }
        break;
      default:
        this.messageService.error('Tela desconhecida: ' + item.tela);
        return;
    }

    window.open(rota, '_blank');
  }



}
